// extracted by mini-css-extract-plugin
export default {"wrap":"AccountDisabledModal_wrap__0CtFM","verticalLine":"AccountDisabledModal_verticalLine__4mIbK","horizontalLine":"AccountDisabledModal_horizontalLine__gBCrY"};